//* Components
import Text from '@/components/common/Text';

const formatPrice = (value) => {
	if (value == null || value === '' || value === '-') return value;
	const num = typeof value === 'number' ? value : parseFloat(String(value).replace(/,/g, ''));
	if (Number.isNaN(num)) return value;
	return num.toFixed(2);
};

const Price = ({ price, sale_price, discount, className, isSecondVersion = false }) => {
	const formattedPrice = formatPrice(price);
	const formattedSalePrice = formatPrice(sale_price);
	return (
		<Text className={`h4 font-futura-medium ${isSecondVersion ? 'second-version' : ''} ${className || ''}`}>
			{price != '-' ? (
				sale_price != null && sale_price !== '' ? (
					<p className='flex-column'>
						<p className='h4'>${formattedSalePrice}</p>
						{discount ? (
							<p className='green'>
								{discount.formatted_value != null ? discount.formatted_value : (discount.type == 'percentage' ? `${discount.value}%` : `$${formatPrice(discount.value)}`)}
							</p>
						) : null}
						<del className='h6 font-futura-regular grey'>${formattedPrice}</del>
					</p>
				) : (
					<span>${formattedPrice}</span>
				)
			) : (
				price
			)}
		</Text>
	);
};

export default Price;
